import React from 'react';
import './MobileSubmenu.css';

const ChevronRight = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="8" height="14" viewBox="0 0 8 14">
        <path d="M1 1l6 6-6 6" stroke="#888" strokeWidth="2" fill="none" fillRule="evenodd" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
);

/**
 * MobileSubmenu - Shared mobile navigation list for section landing pages.
 *
 * Props:
 *   items - Array of { id, title, description, icon, url, badge? }
 *   onNavigate - (url) => void
 */
function MobileSubmenu({ items, onNavigate }) {
    if (!items || items.length === 0) return null;

    return (
        <div className="mobile-submenu-wrapper">
            <div className="container">
                <div className="mobile-submenu">
                    <ul className="list-unstyled m-0 p-0">
                        {items.map((item) => (
                            <li
                                key={item.id}
                                onClick={() => onNavigate(item.url)}
                                className="mobile-submenu-item"
                            >
                                <div className="mobile-submenu-link">
                                    <span className="icon">{item.icon}</span>
                                    <span className="sTitle">
                                        <strong className="d-block">
                                            {item.title}
                                            {item.badge && (
                                                <span className="mobile-submenu-badge">{item.badge}</span>
                                            )}
                                        </strong>
                                        <span className="text-sm d-block">{item.description}</span>
                                    </span>
                                    <span className="arrow">
                                        <ChevronRight />
                                    </span>
                                </div>
                            </li>
                        ))}
                    </ul>
                </div>
            </div>
        </div>
    );
}

export default MobileSubmenu;
